<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "selkavaivat_kuriin_treenaamalla";
    let title = "Selkävaivaisena treenaamisesta";
    let author = "Markus";
    let blogDate = "17.11.2014";
    let titlePic = "2014/levytanko.jpg";
    let firstPara = "Selkävaivat ovat nykyisin valitettavan yleisiä. Tilastojen mukaan vähintään joka kolmas suomalainen sanoo kärsineensä selkävaivoista viimeisen puolen vuoden aikana. Yleisimmit kivut esiintyvät alaselän alueella.";
</script>

<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"/>


        <p>Selkävaivat ovat nykyisin valitettavan yleisiä. Tilastojen mukaan vähintään joka kolmas suomalainen 
        sanoo kärsineensä selkävaivoista viimeisen puolen vuoden aikana. Yleisimmit kivut esiintyvät alaselän alueella.</p>
        
        <p>Selkäongelmat voivat johtua monista syistä. Yleisin syy on lihasperäinen kipu, mutta esimerkiksi välilevyjen tai selkäydinkanavan ongelmat voivat olla ongelmien taustalla.
        Jos kivun lisäksi esiintyy muita oireita, tai kipu on pitkäaikaista, selkäkipu pitäisi aina tutkituttaa asiantuntevalla lääkärillä. Lääkärin tai fysioterapeutin ohjeita on syytä noudattaa. </p>
        
        <p>Tässä tekstissä käyn läpi omakohtaisia kokemuksiani selkävaivaisena treenaamisesta.</p>
        
        <p>Minulla selkäkivut alkoivat jo 18-vuotiaana. Selkäni on kuvattu kahteenkin otteeseen sairaalassa ja diagnoosi on 
        ollut aina sama: rakenteellinen vika, leikkaus ei auta. Lääkärien ohjeet ovat kuitenkin vuosien saatossa muuttuneet. 
        Armeijassa suositeltiin lepoa, nykyään käskettään pitämään selkälihakset kunnossa ja vahvistamaan keskivartalon 
        tukilihaksia.</p>

        <p>Molempia olen antaumuksella yrittänyt noudattaa. Lepääminen johti kyvyttömyyteen liikkua, 
        istua tai maata. Pahimmillaan sain unen vain vahvasti lääkittynä. Nykyään noudatan jälkimmäistä ohjetta.
        Minulla ja monilla muillakin, joiden kanssa olen jutellut ongelmat pahenevat, kun istuu liikaa, passivoituu 
        ja päästää näin lantion ja jalkoljen lihakset kiristymään. Mikäli mistään vakavasta ei ole kyse, selkävaivaisten 
        tulisikin keskittyä aktiiviseen elämäntapaan, venyttelyyn, selän liikuttamiseen sekä selkä- ja vatsalihasten ja 
        koko keskivartalon vahvistamiseen.</p>
        
        <h2>Keskivartalon aktivointi</h2>

        <p>Keskivartalon tukilihasten aktivointiin ei ole olemassa mitään oikotietä. Se voi olla erittäin vaikeaa, 
        ja se on opeteltava pikku hiljaa. Pahinta selälle onkin hallitsematon liike, jossa selkä ns. nitkahtaa.
        On hyvin yleinen ongelma, että keskivartalon tukilihakset eivät aktivoidu oikeassa järjestyksessä.
        Keskivartalon lihasten tulisi aktivoitua ensimmäisenä niin että tuki säilyy kun rankaa kuormitetaan.</p>

        <p>Nykyinen työelämä ja sitä edellyttänyt opiskelu on yhtämittaista istumista. 
        Monet jatkavat tätä istumista myös vapaa-ajallaan. Työmatkat vietetään istuen autossa, illat vietetään 
        istuen sohvalla. Ja sitten ihmetellään, että miksi keskivartalossa ei ole voimaa pitämään selkärankaa suorassa,
        kun sitä kuormitetaan salilla.</p>

        <p>Meidän istumiselämäntapa johtaa siis siihen, että keskivartalon lihaksia tai pakaralihaksia ei tarvita 
        normaalielämässä juurikaan. Pakaralihaksien käytöllä ja jännittämisellä on iso rooli keskivartalon lihaksien 
        aktivoinnissa ja niidenkin toiminta on saatu horjumaan väärillä tottumuksilla. Koko päivä menee istuskellessa 
        alaselkä pyöreänä ja pakaralihakset puristuksissa. Tämän katastrofin nollaamiseksi ei oikein riitä muutama 
        tunnin treeni viikossa.</p>

        <h2>Mitä asian korjaamiseksi voidaan tehdä?</h2>
        <p>Oman kokemukseni mukaan parasta on vain nousta sieltä mukavalta tuolilta ja ruveta aktiiviseksi. Tämä aktiivisuus voi olla ihan tavallisia kotiaskareita, monipuolista liikuntaa, pihahommia tai ylipäätänsä mitä tahansa muuta kuin passiivista olemista. Liike on lääkettä.</p>
        <p>Seuraava askel on keskivartalon aktiivinen käyttö. Joka päivä tulee eteesi lukemattomia tilanteita, joissa voi tarkastella omaa asentoaan ja parantaa keskivartalon tuomaa tukea. Mieti seuraavalla kerralla, miten jännität keskivartalon lihaksia harjatessasi lumia portailta, nostaessasi esineen lattialta tai istuutuessasi ruokapöydän ääreen.</p>
        
        <h2>Harjoitusliikkeiden valinta</h2>
        <p>Meille selkävaivaisille on kuitenkin olemassa toivoa. Kaikkia liikkeitä emme pysty tekemään täysipainoisesti. 
            Silti kehoa pystyy kuormittamaan todella hyvin, kunhan ottaa huomioon muutaman perussäännön.</p>
        <p>Lähtökohtaisesti selkää ei saa päästä notkahtamaan missään tilanteessa. Selkään kohdistuva kuorma saa olla juuri niin suuri, kuin keskivartalon lihaksista saatu tuki on. Suurimman kuorman selälle aiheuttavat raskaat perusliikkeet (kyykky, maastaveto) sekä liikkeet joissa alaselän pitäisi pysyä suorana koko liikkeen ajan kuten voimapyörä, pystypunnerrus. Jälkimmäisessä erityisesti hartioiden liikkuvuus on lisäksi tärkeässä roolissa alaselkään kohdistuvan kuorman suhteen.</p><h4><strong>Etukyykky vs. Takakyykky</h4>
        <p>Etukyykky on minusta huomattavasti paljon turvallisempi liike suorittaa, kuin takakyykky.</p>
        <p>Etukyykyssä tangon paikka kehon etupuolella pakottaa pitämään ylävaratalon suorassa. Jos ylävartalo alkaa kallistumaan eteenpäin, niin tanko tippuu olkapäiltä. Etukyykkyä on siis vaikeampi tehdä selkäsairaille vaarallisessa etukumarassa. Niin hassulta kuin se kuulostaakin, vaatii etukyykky vähemmän liikkuvuutta kuin takakyykky; takakyykky on helpompi suorittaa epäpuhtaasti, jolloin kuormitus selälle kasvaa..</p>
        
        <h3>Askelkyykyt</h3>
        <p>Askelkyykyt ovat vielä etukyykkyäkin parempi vaihtoehto, koska kuormaa on nostamassa vain toinen jalka. Tämä vähentää käytettävää kuormaa ja näin myös alaselälle tuleva rasitus on pienempi. Alaselän vaivat johtavat yleensä jalkojen epätasapainoiseen voimantuottoon. Kahden jalan kyykyissä heikompaa jalkaa ei välttämättä edes huomaa, koska on opittu tekemään kyykyt vahvempaa jalkaa hyödyntäen.</p>
        <p>Askelkyykkyjä on hyvä käyttää myös mittarina sille, että riittääkö oma liikkuvuus etukyykyn tekemiselle. Ottamalla käsipainon tai kahvakuulan ja nostamalla sen pään yläpuolelle näkee heti, pysyykö ylävartalo suorassa. Paino tippuu, jos heikon liikkuvuuden takia lähtee hakemaan etukumaraista asentoa.</p>
        <p>Askelkyykky on sekä teknisesti että liikkuvuuden kannalta helpompi liike kuin levytangolla tehtävä kyykky.
        Lisäksi eri variaatioilla saadaan tehtyä varmasti kattava jalkatreeni turvallisesti. Erilaisia 
        askelkyykkyvaihtoehtoja on esimerkiksi bulgarialaiset kyykyt ja korokkeen päälle askeltaminen. 
        Askelkyykkyä voi käyttää myös ns. etukäteisväsytykseen, jolloin päästään pienempiin kyykkypainoihin ja 
        pienempään alaselälle kohdistuvaan kuormaan..</p>
        
        <h3>Yhden jalan liikkeet vs kahden jalan liikkeet</h3>
        
        <p>Yhden jalan kyykky tai yhden jalan maastaveto on selälle usein turvallisempi vaihtoehto kuin molemmilla 
        jaloilla suoritettavat vastaavat liikkeet. Tällöin liikkeissä käytettävät painot tippuvat väkisinkin puoleen tai 
        jopa kolmasosaan kuormituksen ollessa edelleen harjoitettavalle raajalle erittäin kova. Yhdellä jalalla 
        suoritettavissa liikkeissä samalla tärkeät tukilihakset saavat uudenlaista herätettä ja vahvistuvat, kun 
        kuorma ei ole enää tukevasti kahden jalan päällä.</p>
        
        <h4>Kipua tuottavat liikkeet: Hypyt, vatsarutistukset ja jalkojen nostot</h4>
        
        <p>Kun selkä on todella kipeä, on mahdotonta hypellä tai tehdä vatsarutistuksia tai jalkojen nostoja. 
        En suosittele kenellekään mitään liikettä, joka tuottaa kipua. Välillä on kuitenkin hyvä kokeilla, mitä eri 
        päivinä pystyy tekemään.</p>

        <p>Hyppyjen tuomaa harjoitusvastetta on vaikea korvata. Räjähtävää voimaa kehittävät liikkeet eivät kuitenkaan 
        ole terveysliikkujalle välttämättömiä ja ne voidaan korvata tarvittaessa muilla turvallisemmilla liikkeillä.</p>

        <p>Keskivartalon lihaksia tulisi rasittaa ja kehittää monipuolisesti, vaikka ei pystysikään tekemään 
        vatsarutistuksia tai erilaisia jalkojen nostoja. Farmarikävely, hollow asento, lankku ja muut staattista 
        jännitystä vaativat keskivartalon liikkeet ovat erinomaisia liikkeitä kaikille selkäsairaille. Keskivartalon 
        lihasten ensisijainen toiminta on pitää keskivartalo suorassa. Vaikka vatsarutistukset eivät kuntotuksen 
        alkuvaiheessa onnistuisikaan, ei kannata olla huolisaan. Staattisilla pidoilla saadaan rakennettua vahva 
        keskivartalo.</p>
        
        <h2>Liikkuvuus</h2>
        
        <p>Hyvä liikkuvuus auttaa välttämään ja vähentämään selkävaivoja. Omasta liikkuvuudesta pitäisi huolehtia 
        mustasukkaisen tarkasti. Säännöllisen venyttelyn pitäisi kuulua jokaisen selkävaivoista kärsivän viikko-ohjelmaan. 
        Omaa liikkuvuutta voi parantaa monin tavoin esimerkiksi staattisilla ja dynaamisilla venytyksillä, 
        putkirullauksella ja hieronnalla.</p>

        <p>Selkävaivaisille helpotusta tuo jo se, että pakarat, lonkan alueen lihakset sekä takareidet ovat hyvässä 
        kunnossa - sopivasti vahvat ja liikkuvat. Muitakaan lihaksia ei sovi unohtaa. 
        Lapojen ja hartioiden alueen sekä etureisien ja lantion alueen on myös oltava kunnossa, jotta niiden aiheuttamat 
        heikkoudet tai kireydet eivät aiheuta kompensaatiota muualla kehossa. Esimerkiksi seisten pään yläpuolelle 
        punnertaessa puutteellinen olkapäiden liikkuvuus kostautuu kompensaatiolla alaselässä.</p>

        <p>Liikkuvuutta ei kannata tuhota liian kovalla harjoittelulla. Homma lähtee lapasesta helposti, on mahtavaa 
        tehdä sellainen treeni, että liikkuminen tekee kipeää seuraavana päivänä. Selkäsairaille tällainen ei vain 
        mielestäni ole se fiksuin tapa treenata. Kovat treenit jäykistävät koko kehon.</p>

        <p>Yritänkin aktiivisesti muistaa ja pakottaa itseni tekemään useampia kevyitä treenejä viikossa, jolloin pystyn 
        pitämään tai jopa kehittämään liikkuvuuttani. Muutama kova treeni putkeen johtaa kokovartalojumiin, jonka 
        aukaisuun menee useita päiviä. Ja jos ollaan aina siinä tilanteessa, että pyritään vain aukaisemaan 
        harjoittelun synnyttämiä jumeja, ei koskaan päästä liikkuvuuden parantamiseen. Tähän itselläni on lääkkeenä 
        treenien pilkkominen niin, että kerralla rasitus pidetään pienempänä, mutta vastaavasti treenataan useammin.</p>
        
        <p>Treenatkaahan kovaa ja fiksusti!</p>

        <p>- Markus</p>
    
    </article>



    <section class="container">
        <h2>Lue seuraavaksi</h2>
        <div class="row">
            <article class="blog col-xs-12 col-md-4">
                <BlogSummary blogPath='6-syyta-tehda-nopeusvoimaharjoittelua' title='6 syytä tehdä nopeusvoimaharjoittelua' titlePic='nopeusharjoittelu.jpg' blogDate='' firstPara='Lihasten tuottama voima voidaan lajitella käytännössä kolmeen luokkaan. Kaiken kivijalka on kestovoima, jonka päälle rakennetaan maksimi- ja nopeusvoima.'></BlogSummary>
            </article>
            <article class="blog col-xs-12 col-md-4">
                <BlogSummary blogPath='vastuskuminauhat_6_vinkkia' title='6 vinkkiä vastuskuminauhojen hyödyntämiseen' titlePic='2014/etunojapunnerrus2.jpg' blogDate='' firstPara='Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.'></BlogSummary>
            </article>
            <article class="blog col-xs-12 col-md-4">
                <BlogSummary blogPath='stressaako' title='Stressaako?' titlePic='stressi.jpg' blogDate='' firstPara='Viime aikoina on puhuttu paljon stressistä ja sen vaikutuksista. Pitkittyneellä stressireaktiolla on yhteys elimistön lievään tulehdustilaan, joka voi johtaa monenlaisiin ongelmiin.'></BlogSummary>
            </article>
        </div>
    </section>

</div>

{/if}

<style>
</style>
